<template>
    <q-modal v-model="show_billing_reports_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '60vh'}" @hide="hideBillingReports()">
        <q-modal-layout>
            <q-toolbar slot="header">
            <q-btn flat round dense @click="hideBillingReports()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('billing_reports') }}
                </q-toolbar-title>
            </q-toolbar>
            <div class="q-ma-md q-pa-md col-xs-12 col-sm-12">
                    <!-- :pagination.sync="server_pagination" -->
                <q-table
                    :data="billing_reports"
                    :columns="columns"
                    @request="requestReports"
                    :loading="loading"
                    row-key="id"
                    :no-data-label="$t('no_data_avaliable')"
                    :no-results-label="$t('no_results_found')"
                    :loading-label="$t('loading_data')"
                    :rows-per-page-label="$t('items_per_page')"
                    :rows-per-page-options="[5,10,50,100]"
                    class="q-mt-md"
                    binary-state-sort
                    >

                    <q-tr slot="header" slot-scope="props" :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                        </q-th>
                    </q-tr>

                    <q-tr slot="body" slot-scope="props">
                        <q-td auto-width key="download_link" :props="props">
                            <q-btn flat color="secondary" icon="fal fa-download" @click="downloadReport(props.row.download_link)"/>
                        </q-td>

                        <q-td key="report" :props="props">
                            {{ props.row.report }}
                        </q-td>

                        <q-td key="timeline" :props="props">
                            {{ props.row.timeline }}
                        </q-td>
                    </q-tr>
                </q-table>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
    name: 'AdminBillingReports',

    props: ['show'],

    data() {
        return {
            loading: false,
            billing_reports: [],
            columns: [
                {
                    name: 'download_link',
                    required: true,
                    label: 'download',
                    align: 'center',
                    field: 'download',
                    sortable: false,
                    show: false
                },
                {
                    name: 'report',
                    required: true,
                    label: 'report',
                    align: 'center',
                    field: 'report',
                    sortable: false,
                },
                {
                    name: 'timeline',
                    required: true,
                    label: 'timeline',
                    align: 'center',
                    field: 'timeline',
                    sortable: false,
                },
            ]
        }
    },

    computed: {
        show_billing_reports_modal: {
            get() {
                return this.show
            },
            set() {
                this.$emit('hideBillingReports')
            }
        },
    },

    methods: {
        async requestReports() {
            this.loading = true
            // const response = await this.$axios.get(`/presential/presential_events/list_presential_events/?${this.$qs.stringify(data, { arrayFormat: 'repeat' })}`, this.getHeader)
            // const data = await fake()
            this.billing_reports = data
            this.loading = false
        },

        downloadReport(url) {
            console.log(url)
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        hideBillingReports() {
            this.$emit('hideBillingReports')
        },
    },

    mounted () {
        const response = [
                    {
                        download_link: 'www.google.com',
                        report: 'Cobranca_Portal UC_Mês_Ano_Pós-Vendas',
                        timeline: '09/2020'
                    },
                    {
                        download_link: 'www.google.com',
                        report: 'Cobrança_Portal UC_Mês_Ano_Vendas',
                        timeline: '09/2020'
                    },
                    {
                        download_link: 'www.google.com',
                        report: 'Capacitação Vendas_Mês_Ano',
                        timeline: '10/2020'
                    },
                    {
                        download_link: 'www.google.com',
                        report: 'Capacitação Pós Vendas_Mês_Ano',
                        timeline: '10/2020'
                    }
                ]
                this.billing_reports = response
    },
}
</script>

<style>

</style>
